var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path6, _path7, _path8, _g, _rect, _path9, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 154,
    viewBox: "0 0 274 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 111C130.51 111 152 89.5097 152 63C152 36.4903 130.51 15 104 15C77.4903 15 56 36.4903 56 63C56 89.5097 77.4903 111 104 111Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 147C144.719 147 168 123.719 168 95C168 66.2812 144.719 43 116 43C87.2812 43 64 66.2812 64 95C64 123.719 87.2812 147 116 147Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 154C184.719 154 208 130.719 208 102C208 73.2812 184.719 50 156 50C127.281 50 104 73.2812 104 102C104 130.719 127.281 154 156 154Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168 123C196.719 123 220 99.7188 220 71C220 42.2812 196.719 19 168 19C139.281 19 116 42.2812 116 71C116 99.7188 139.281 123 168 123Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137 96C163.51 96 185 74.5097 185 48C185 21.4903 163.51 0 137 0C110.49 0 89 21.4903 89 48C89 74.5097 110.49 96 137 96Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 81,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 141,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 146,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 61.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 10.5,
    r: 1.5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5 110.5L250 115.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5L40.5 24",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 126L23 119",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11400_12682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.001 130.001C166.72 130.001 190.001 106.72 190.001 78.001C190.001 49.2822 166.72 26.001 138.001 26.001C109.282 26.001 86.001 49.2822 86.001 78.001C86.001 106.72 109.282 130.001 138.001 130.001Z",
    fill: "#006CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.702 86.7749L144.223 85.6583C142.309 82.6277 141.352 78.3209 141.033 73.8546C140.554 63.4865 144.223 55.3516 150.125 54.873H150.444C155.708 54.873 160.493 62.2105 161.291 72.2596C161.61 76.7258 160.972 80.873 159.696 84.2227L159.377 85.3393H158.26C156.346 85.0203 153.953 85.0203 152.199 85.3393C150.125 85.3393 147.892 85.9773 146.137 86.4559L144.702 86.7749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.462 83.9028L131.94 82.7863C133.855 79.7556 134.812 75.4488 135.131 70.9826C135.609 60.6145 131.94 52.4795 126.039 52.001H125.879C120.615 52.001 115.83 59.3384 115.032 69.3875C114.713 73.8537 115.351 78.001 116.628 81.3507L116.947 82.4672H117.904C119.818 82.1482 122.21 82.1482 123.965 82.4672C126.039 82.4672 128.272 83.1053 130.026 83.5838L131.462 83.9028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.082 104.161C146.616 104.161 143.585 98.8974 143.904 92.517C143.904 92.0385 143.904 91.2409 143.904 90.7624L144.223 89.4863L158.419 89.9649V91.4004C158.419 91.879 158.419 92.6765 158.419 93.155C158.579 99.3759 155.229 104.161 151.082 104.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.923 101.289C129.389 101.289 132.42 96.0253 132.101 89.6449C132.101 89.1664 132.101 88.3689 132.101 87.8903L131.782 86.6143L117.585 87.0928V88.3689C117.585 88.8474 117.585 89.6449 117.585 90.1235C117.426 96.3443 120.935 101.289 124.923 101.289Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 22,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(5 205 22)",
    fill: "#FFB925"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.377 52.904L226.688 36.1711L239.783 37.3169L235 48.2467L242.465 48.8998L225.565 70.118L228.877 53.3852L223.377 52.904Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11400_12682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7002 111.766C64.0795 110.15 75.2364 96.3723 73.62 80.993C72.0036 65.6138 58.2259 54.4568 42.8466 56.0732C27.4674 57.6896 16.3104 71.4674 17.9268 86.8466C19.5432 102.226 33.3209 113.383 48.7002 111.766Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5537 72.5724C47.2319 73.1432 46.0404 74.132 45.0377 75.2738C43.7341 74.3745 42.4484 73.646 41.0368 73.3625C35.8355 72.3547 32.0673 77.587 32.5611 82.2851C33.4948 91.1686 45.6274 98.9615 47.5066 98.764C49.3858 98.5665 59.642 88.5068 58.6993 79.5378C58.2055 74.8398 53.261 70.5232 48.5537 72.5724Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11400_12682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(86 26)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11400_12682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(15 59) rotate(-6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIndex);
export default __webpack_public_path__ + "static/media/activity-index.161be50bbf171e609179aa8088b15df6.svg";
export { ForwardRef as ReactComponent };